import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import httpClient from "../../HTTPService";
import noImage from "../../assets/noimage.jpg"
import moment from "moment";
function Income() {
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search); // Parse query string
    const id = queryParams.get('id');
    const [accouuntDetaila, setaccountDetails] = useState()
    const [accountDetails, setAccouuntDetails] = useState()
    const navigate = useNavigate()
    const [withdrawalList, setWithdrawalList] = useState([])
    const [fundingDatalist, setfundingDatalist] = useState([])
    const [uplineData, setUplineData] = useState([])

    const [currentsuerview, setCurrenuserview] = useState('WITH_DRAWAL')
    useEffect(() => {
        getMembersDetailsView()
        getwithdrawalListData()
        getfundingDetails()
        getUplineData()
    }, [])
    const getwithdrawalListData = async () => {
        try {
            const result = await httpClient.post('/admin/members-withdraw-list', { user_id: id }, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })
            console.log(result?.data.data, 'fjelkfjdkf')
            if (result.status === 200) {
                // console.log(result.data ,'withdrawl list...')
                setWithdrawalList(result?.data?.data)
            }

        } catch (error) {
            //   toast.error(error.message)
        }
    }
    const getfundingDetails = async () => {
        try {
            const result = await httpClient.post('/admin/members-funding-details', { user_id: id }, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })
            console.log(result?.data.data, 'fjelkfjdkf')
            if (result.status === 200) {
                // console.log(result.data ,'withdrawl list...')
                setfundingDatalist(result?.data?.data)
            }

        } catch (error) {
            //   toast.error(error.message)
        }
    }
    const getMembersDetailsView = async () => {
        try {
            const result = await httpClient.post('/admin/members-view', { id: id }, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })
            console.log(result?.data.data, 'fjelkfjdkf')
            if (result.status === 200) {
                console.log(result.data?.data, 'data..')
                setaccountDetails(result.data?.data)
                setAccouuntDetails(result.data?.member_details)
                // setBusinessProfiles(result.data?.profiles)
                // setBankdetails(result.data?.bank_accounts[0])
                // setmemberlist(result?.data?.data)
            }

        } catch (error) {
            //   toast.error(error.message)
        }
    }

    const getUplineData = async () => {
        try {
            const result = await httpClient.post('/admin/depth-upline-member-list', {

                user_id: id,

            }, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            if (result.status === 200) {
                let week_arr = []
                console.log(result.data.data, 'data..')
                // setTotalCount(result?.data.total_count)
                const reversedLevels = await result?.data?.data?.map(item => item.level).reverse();
                const result_ = await result?.data?.data?.map((item, index) => ({
                    ...item,
                    level: reversedLevels[index]
                }));
                setUplineData(result?.data?.data)

                // setweeklyData(result?.data?.weekly_report_data)
            }

        } catch (error) {
            //   toast.error(error.message)
        }
    }

    return (
        <>
            <div className="header-back"
                onClick={() => navigate('/member', {
                    state: {
                        backpagi: location?.state?.paginationState
                    }
                })}
            >
                <div></div>
                <div className="back-button">
                    <i class="fa fa-arrow-left back-arrow-button"
                        // className="back-arrow-button"
                        aria-hidden="true"></i>
                </div>

            </div>
            <div style={{
                display: 'flex',
                width: 400,
                display: 'flex',
                justifyContent: 'space-between'
                // flexDirection:'column'
            }}>
                <h5>Income Page</h5>
                <h5>Total Earning - {(Number(accountDetails?.depth_1_total_commission) + Number(accountDetails?.depth_2_total_commission))?.toFixed(2)}</h5>

            </div>

            <div className="row">

                <div className="card col-md-5">

                    <h5>Profile Details</h5>

                    {/* <div className="acc-profile-image-section ">
                        
                        <p>Profile Image :</p>
                        
                        <div className="acc-details-image">
                            <div className="image-container">
                                <img
                                    className="image-acc-details"
                                    src={accouuntDetaila?.profile_photo_url !== null ?

                                        accouuntDetaila?.profile_photo_url : noImage
                                    }></img>
                            </div>

                            <div>

                                <span className={accouuntDetaila?.active == 1 ? "active_profile" : "inactive_profile"}>{accouuntDetaila?.active == 1 ? "Active" : "Inactive"}</span>
                            </div>
                        </div>
                    </div> */}


                    <div className="account-details" style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between'
                    }}>
                        <div>
                            <p>Name : {accouuntDetaila?.name} </p>
                            {/* <p className="ml-2"></p> */}
                        </div>



                        <div>

                            <span className={accouuntDetaila?.active == 1 ? "active_profile" : "inactive_profile"}>{accouuntDetaila?.active == 1 ? "Active" : "Inactive"}</span>
                        </div>



                    </div>
                    {/* <div className="account-details">
                        <p>Email : </p>
                        <p className="ml-2"> {accouuntDetaila?.email}</p>
                    </div> */}
                    <div className="account-details">
                        <p>Phone : </p>
                        <p className="ml-2">{accouuntDetaila?.phone}</p>
                    </div>
                    <div className="account-details">
                        <p>Member Id : </p>
                        <p className="ml-2">{accouuntDetaila?.user_referral_code}</p>
                    </div>
                    <div className="account-details">
                        <p>Joining Date : </p>
                        <p className="ml-2">{accouuntDetaila?.joing_date !== null ?
                            moment(accouuntDetaila?.joing_date).format('DD-MM-YYYY') : null}</p>
                    </div>
                    <div className="account-details">
                        <p>Refered By : </p>
                        <p className="ml-2">{accouuntDetaila?.referral_code !== null ?
                            accouuntDetaila?.referral_code : null}</p>
                    </div>
                    <div className="account-details" style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between'
                    }}>
                        <p>Depth Line : <span style={{ color: 'green' }}> {uplineData?.length} </span></p>

                        <button type="button" class="btn btn-primary" data-toggle="modal" data-target=".bd-example-modal-lg">Check UP-line</button>

                    </div>
                    <div className="addres-account-details">
                        <p>Address:
                            {`${accouuntDetaila?.state !== null ? `${accouuntDetaila?.state?.name},` : ''}
                         ${accouuntDetaila?.district !== null ? `${accouuntDetaila?.district?.district_name},` : ''} 
                         ${accouuntDetaila?.city !== null ? `${accouuntDetaila?.city},` : ''}
                         ${accouuntDetaila?.pin_code !== null ? `${accouuntDetaila?.pin_code}` : ''}`}
                        </p>
                    </div>
                    <div className="account-details" style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexDirection: 'row'
                    }}>
                        <p>Position : </p>
                        <button type="button"
                            style={{
                                backgroundColor: accouuntDetaila?.active == 1 ? 'green' : 'red',
                                border: 'none',
                                fontSize: 12,
                                color: 'white'
                            }}
                            data-toggle="modal" data-target=".bd-example-modal-lg">{accouuntDetaila?.position !== null ?
                                accouuntDetaila?.position : null}</button>

                        {/* <h6 className="ml-2 user-position" style={{
                            backgroundColor: accouuntDetaila?.active == 1 ? 'green' : 'red'
                        }}

                        >{accouuntDetaila?.position !== null ?
                            accouuntDetaila?.position : null}</h6> */}
                    </div>
                    <div className="account-details">
                        <p>Become Active On : {moment(accountDetails?.member_active_date).format('DD-MM-YYYY')}</p>
                        {/* <p className="ml-2">{accouuntDetaila?.referral_code !== null ?
                            accouuntDetaila?.referral_code : null}</p> */}
                    </div>
                    <div className="account-details">
                        <p>Last Open On :  { accountDetails?.last_login && moment(accountDetails?.last_login).format('DD-MM-YYYY')}  {accountDetails?.last_login && moment(accountDetails?.last_login).format('LT')}</p>
                        {/* <p className="ml-2">{accouuntDetaila?.referral_code !== null ?
                            accouuntDetaila?.referral_code : null}</p> */}
                    </div>

                </div>
                <div className=" col-md-7"
                    style={{
                        // marginLeft:20
                    }}
                >
                    <div className="row">
                        <div className="card income-view-box col-md-5" style={{
                            marginLeft: 10
                        }}>
                            <div>
                                <h6>Direct Member: {accountDetails?.depth_1_per_member_commission}%</h6>
                                <p className="member-butonborder"></p>
                            </div>

                            <p >Direct paid member: {accountDetails?.total_depth_1_paid_members}</p>
                            <p >Used Sub Cate: {accountDetails?.depth_1_used_subcategory}</p>
                            <p >Added Sub Cate: {accountDetails?.depth_1_add_subcategory}</p>

                            {/* <p>Per Member : {accountDetails?.depth_1_per_member_commission}</p> */}
                            <p>D1 Total Earning : {accountDetails?.depth_1_total_commission}</p>
                        </div>
                        <div className="card income-view-box2 col-md-5 ml-4" style={{
                            marginLeft: 10
                        }}>
                            <div>
                                <h6>Depth 2 Member: {accountDetails?.depth_2_per_member_commission}%</h6>
                                <p className="member-butonborder"></p>
                            </div>

                            <p>Depth 2 paid member: {accountDetails?.total_depth_2_paid_members}</p>
                            <p >Used Sub Cate: {accountDetails?.depth_2_used_subcategory}</p>
                            <p >Added Sub Cate: {accountDetails?.depth_2_add_subcategory}</p>
                            {/* <p>Per Member : {accountDetails?.depth_2_per_member_commission}</p> */}
                            <p>D2 Total Earning : {accountDetails?.depth_2_total_commission}</p>
                        </div>


                    </div>
                    <div className="row">
                        <div className="card income-view-box col-md-5" style={{
                            cursor: 'pointer',
                            // backgroundColor: currentsuerview == 'WITH_DRAWAL' ? '#22b14c' : '',
                            marginLeft: 10
                        }}

                            onClick={() => {
                                navigate(`/member-withdraw?id=${id}?history`)
                            }}
                        >
                            <h5>Withdrawal History</h5>
                        </div>
                        <div className="card income-view-box col-md-5 ml-4" style={{
                            cursor: 'pointer',
                            // backgroundColor: currentsuerview == 'FUND_DETAILS' ? '#22b14c' : '',
                            marginLeft: 10

                        }}
                            onClick={() => {
                                navigate(`/member-withdraw?id=${id}?funding`)
                            }}
                        >
                            <h5>Funding Details</h5>
                        </div>


                    </div>



                </div>

            </div>
            <div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content" style={{
                        padding: 20
                    }}>
                        <div class="row">
                            <h5>Up Line Members</h5>
                            <div class="col-md-12">
                                <div class="table-responsive">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th>SL NO</th>
                                                <th> Member ID</th>
                                                <th>Name</th>
                                                {/* <th>Validity</th>
                <th >Description</th> */}
                                                {/* <th>Discount</th>
                <th>Price</th> */}

                                                <th>Mobile</th>
                                                <th>Address</th>
                                                <th>Joing Date</th>
                                                <th>Depth Line</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                uplineData?.map((item, index) => {
                                                    return (
                                                        <>
                                                            <tr>
                                                                <td
                                                                    style={{
                                                                        backgroundColor: item?.phone == null ? 'gray' : 'transparent',
                                                                        color: item?.phone == null ? 'white' : 'black'
                                                                    }}
                                                                >{index + 1}</td>

                                                                <td
                                                                    style={{
                                                                        backgroundColor: item?.phone == null ? 'gray' : 'transparent',
                                                                        color: item?.phone == null ? 'white' : 'black'
                                                                    }}
                                                                >{item?.member_code}</td>
                                                                <td
                                                                    style={{
                                                                        backgroundColor: item?.phone == null ? 'gray' : 'transparent',
                                                                        color: item?.phone == null ? 'white' : 'black'
                                                                    }}
                                                                >

                                                                    <div style={{ display: 'flex', flexDirection: 'column' }}>

                                                                        {item?.name}
                                                                        {item?.active == 1 ?
                                                                            <span className="ml-2 active_profile_table" style={{
                                                                                color: 'green'
                                                                            }}>Active</span>
                                                                            :
                                                                            <span className="ml-2 inactive_profile_table" style={{
                                                                                color: 'red'
                                                                            }}>Inactive</span>
                                                                        }
                                                                    </div>
                                                                </td>
                                                                <td
                                                                    style={{
                                                                        backgroundColor: item?.phone == null ? 'gray' : 'transparent',
                                                                        color: item?.phone == null ? 'white' : 'black'
                                                                    }}
                                                                >{item?.phone}</td>
                                                                <td
                                                                    style={{
                                                                        backgroundColor: item?.phone == null ? 'gray' : 'transparent',
                                                                        color: item?.phone == null ? 'white' : 'black'
                                                                    }}
                                                                >{item?.address !== null ? item?.address : '--'}</td>
                                                                <td
                                                                    style={{
                                                                        backgroundColor: item?.phone == null ? 'gray' : 'transparent',
                                                                        color: item?.phone == null ? 'white' : 'black'
                                                                    }}
                                                                >{moment(item?.joing_date).format('DD-MM-YYYY')}</td>
                                                                <td
                                                                    style={{
                                                                        backgroundColor: item?.phone == null ? 'gray' : 'transparent',
                                                                        color: item?.phone == null ? 'white' : 'black'
                                                                    }}
                                                                >{item?.level}</td>
                                                            </tr>
                                                        </>
                                                    )
                                                })
                                            }


                                        </tbody>

                                    </table>
                                    <div className='nodata-found-div'>
                                        {
                                            uplineData?.length == 0 ?
                                                <p>No Data Found</p>
                                                //  <img 
                                                //  className='table-image'
                                                //  src={require('../../assets/OIP.png')}/>
                                                : null
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Income